import { combineReducers } from "redux";
import item from "./item";
import byId from "./byId";
import deleteErrors from "./deleteErrors";

export default combineReducers({ item, byId, deleteErrors });



// WEBPACK FOOTER //
// ./src/reducers/accessCard/index.js